var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 18 19",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.803 9.362a2.887 2.887 0 1 0 0-5.775 2.887 2.887 0 0 0 0 5.775zm2.021.722h-.376a3.93 3.93 0 0 1 -3.29 0h-.376a3.033 3.033 0 0 0 -3.032 3.032v.938c0 .598.485 1.083 1.083 1.083h7.94c.598 0 1.083-.485 1.083-1.083v-.938a3.033 3.033 0 0 0 -3.032-3.032z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ccf8176c8bfa9a079427e46f97dc094a.svg";
export { ForwardRef as ReactComponent };